import facebook from '../assets/vectors/facebook.svg'

export const socialMedia = [
    {
        name: 'facebook',
        link: 'https://www.facebook.com/MercePolska',
        icon: facebook,
    },
]